// extracted by mini-css-extract-plugin
export default {"footer":"ssEmQ4","notification-bar-cart":"uEbelo","notificationBarCart":"uEbelo"};